import { TextInput } from '@mantine/core'

interface PhoneInputProps {
  value?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  [key: string]: any
}

export default function PhoneInput({ value, onChange, ...props }: PhoneInputProps) {
  const formatPhoneNumber = (value: string) => {
    const digits = value.replace(/\D/g, '')

    if (digits.length <= 3) {
      return digits
    } else if (digits.length <= 6) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
    } else if (digits.length <= 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
    } else {
      return `+${digits.slice(0, digits.length - 10)} (${digits.slice(-10, -7)}) ${digits.slice(-7, -4)}-${digits.slice(-4)}`
    }
  }


  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhoneNumber(event.target.value)

    if (onChange) {
      // Create a proper synthetic event for Mantine form compatibility
      const syntheticEvent = {
        ...event,
        target: { ...event.target, value: formatted }
      } as React.ChangeEvent<HTMLInputElement>

      onChange(syntheticEvent)
    }
  }

  return (
    <TextInput
      label="Phone Number"
      sx={{
        label: {
          fontFamily: 'Plus Jakarta Sans',
          color: '#111928',
          fontSize: '1em',
        },
        input: {
          backgroundColor: '#F9FAFB',
          height: '3em',
          borderRadius: '0.7em',
          color: '#6B7280',
          borderWidth: '1px',
          borderColor: '#D1D5DB',
          fontSize: '1.25em',
          fontFamily: 'Plus Jakarta Sans',
        },
      }}
      value={value}
      onChange={handleChange}
      {...props}
    />
  )
}
